<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card class="do-not-print">
                    <v-col cols="12" lg="8" offset-lg="2">
                        <v-row >
                            <v-col cols="12">
                                <h2 class="text-center">Husbandry Room Activity Report</h2>
                            </v-col>
                        </v-row>

                        <!-- for some reason, using grid-list-md here gives the elements some spacing (eg otherwise the buttons in adjacent flexes touch each other) -->
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-menu
                                        v-model="showSearchStartDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="search.startDate ? $moment(search.startDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                                label="Start Date"
                                                readonly
                                                prepend-icon="event"
                                                append-icon="close"
                                                @click:append="searchStartDateChanged(null)"
                                                v-on="on"
                                            >
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-if="showSearchStartDate"
                                            :value="search.startDate"
                                            @input="searchStartDateChanged($event)">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-menu
                                        v-model="showSearchEndDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="search.endDate ? $moment(search.endDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                                label="End Date"
                                                readonly
                                                prepend-icon="event"
                                                append-icon="close"
                                                @click:append="searchEndDateChanged(null)"
                                                v-on="on"
                                            >
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-if="showSearchEndDate"
                                            :value="search.endDate"
                                            @input="searchEndDateChanged($event)">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" class="text-center" v-if="search.endDate">
                                    Please note that there might be performance issues with queries over a date range larger than a month
                                </v-col>
                                <v-col cols="12" sm="9">
                                    <v-btn block color="primary" :disabled="!canSearch" @click="performSearch" :loading="loading">Search</v-btn>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-btn block color="secondary" :disabled="!canSearch" @click="print" :loading="loading">Print</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="loadError">
                                    <v-alert outlined :value="true" color="error" icon="error">
                                        {{loadError}}
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-container>

                    </v-col>
                </v-card>
                <v-card>
                    <v-row  v-if="!loading">
                        <v-col cols="12" lg="8" offset-lg="2" v-if="data">
                            <HusbandryRoomActivityReportDay
                                v-for="(day, index) in data.DayList"
                                :key="day"
                                :data="data"
                                :index="index"
                            >
                            </HusbandryRoomActivityReportDay>
                        </v-col>
                    </v-row>
                    <v-row  v-else>
                        <v-col cols="12">
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
// APIs
import * as DailyHusbandryAPI from "@/services/dailyHusbandryAPI";

// components
import HusbandryRoomActivityReportDay from "@/components/reporting/HusbandryRoomActivityReportDay.vue";

export default {
    components: {
        HusbandryRoomActivityReportDay
    },
    data() {
        return {
            // displaying the date pickers
            showSearchStartDate: false,
            showSearchEndDate: false,

            // show a loading indicator while search is in progress
            loading: false,

            // display load errors
            loadError: null,

            // the actual report data
            data: null,
            
            // this is what gets sent to the server as parameters
            search: {
                startDate: null,
                endDate: null
            }
        }
    },
    computed: {
        canSearch() {
            // !! converts to boolean
            return !!this.search.startDate;
        }
    },
    methods: {
        searchStartDateChanged(newValue) {
            this.search.startDate = newValue;

            this.showSearchStartDate = false;
        },
        searchEndDateChanged(newValue) {
            this.search.endDate = newValue;

            this.showSearchEndDate = false;
        },
        print() {
            window.print();
        },
        async loadData() {
            try {
                this.loading = true;
                this.loadError = false;

                this.data = await DailyHusbandryAPI.fetchDailyHusbandryRoomReportData(this.search);
            }
            catch (e) {
                this.loadError = e;
            }
            finally {
                this.loading = false;
            }
        },
        performSearch() {
            this.loadData();
        }
    },
    created() {

    }
}
</script>

<style>
</style>